import { render, staticRenderFns } from "./foodsuggestiondetails.vue?vue&type=template&id=9e6fa8c4&scoped=true&"
import script from "./foodsuggestiondetails.vue?vue&type=script&lang=js&"
export * from "./foodsuggestiondetails.vue?vue&type=script&lang=js&"
import style0 from "./foodsuggestiondetails.vue?vue&type=style&index=0&id=9e6fa8c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e6fa8c4",
  null
  
)

export default component.exports